import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
const SIZE_CLASSES = {
    sm: 'h-9 w-9',
    md: 'h-11 w-11',
    lg: 'h-[52px] w-[52px]',
};
const VARIANT_CLASSES = {
    default: 'bg-[rgba(15,20,31,0.55)] border-white/[0.14]',
    strong: 'bg-[rgba(15,20,31,0.72)] border-white/[0.2]',
};
export const GlassCircle = forwardRef(({ size = 'md', variant = 'default', className = '', type = 'button', children, ...rest }, ref) => {
    const classes = [
        'inline-flex items-center justify-center',
        'rounded-full border text-white',
        'backdrop-blur-md',
        'transition-colors',
        'motion-reduce:transition-none',
        'hover:bg-[rgba(15,20,31,0.7)]',
        'active:scale-95 motion-reduce:active:scale-100',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/50 focus-visible:ring-offset-2 focus-visible:ring-offset-transparent',
        'disabled:opacity-50 disabled:pointer-events-none',
        SIZE_CLASSES[size],
        VARIANT_CLASSES[variant],
        className,
    ]
        .filter(Boolean)
        .join(' ');
    return (_jsx("button", { ref: ref, type: type, "data-testid": "glass-circle", className: classes, ...rest, children: children }));
});
GlassCircle.displayName = 'GlassCircle';
